'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEPRECATEDclassKeyFromEnumSet = DEPRECATEDclassKeyFromEnumSet;
exports.classKeyFromEnumSet = classKeyFromEnumSet;
exports.getClasses = getClasses;
exports.ENUMS = exports.DEFAULTS = exports.themes = exports.paddings = exports.dividers = exports.containerClasses = exports.LunaContainerThemes = exports.LunaContainerMargins = exports.LunaContainerPaddings = exports.LunaContainerDividers = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _themes;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var helper = require('../../helper.js');

var __baseClass = 'luna-container';
var LunaContainerDividers = {
  direction: {
    all: 'all',
    horizontal: 'horizontal',
    vertical: 'vertical',
    top: 'top',
    right: 'right',
    bottom: 'bottom',
    left: 'left'
  },
  size: {
    ten: '10',
    twenty: '20',
    thirty: '30',
    fourty: 'DEPRECATED40',
    forty: '40'
  },
  l10: {
    all: 'divider-10',
    horizontal: 'divider-horizontal-10',
    vertical: 'divider-vertical-10',
    top: 'divider-top-10',
    right: 'divider-right-10',
    bottom: 'divider-bottom-10',
    left: 'divider-left-10'
  },
  l20: {
    all: 'divider-20',
    horizontal: 'divider-horizontal-20',
    vertical: 'divider-vertical-20',
    top: 'divider-top-20',
    right: 'divider-right-20',
    bottom: 'divider-bottom-20',
    left: 'divider-left-20'
  },
  l30: {
    all: 'divider-30',
    horizontal: 'divider-horizontal-30',
    vertical: 'divider-vertical-30',
    top: 'divider-top-30',
    right: 'divider-right-30',
    bottom: 'divider-bottom-30',
    left: 'divider-left-30'
  },
  l40: {
    all: 'divider-40',
    horizontal: 'divider-horizontal-40',
    vertical: 'divider-vertical-40',
    top: 'divider-top-40',
    right: 'divider-right-40',
    bottom: 'divider-bottom-40',
    left: 'divider-left-40'
  }
};
exports.LunaContainerDividers = LunaContainerDividers;
var LunaContainerPaddings = {
  direction: {
    all: 'all',
    horizontal: 'horizontal',
    vertical: 'vertical',
    top: 'top',
    right: 'right',
    bottom: 'bottom',
    left: 'left'
  },
  size: {
    ten: '10',
    twenty: '20',
    thirty: '30'
  },
  l10: {
    all: 'padding-10',
    horizontal: 'padding-horizontal-10',
    vertical: 'padding-vertical-10',
    top: 'padding-top-10',
    right: 'padding-right-10',
    bottom: 'padding-bottom-10',
    left: 'padding-left-10'
  },
  l20: {
    all: 'padding-20',
    horizontal: 'padding-horizontal-20',
    vertical: 'padding-vertical-20',
    top: 'padding-top-20',
    right: 'padding-right-20',
    bottom: 'padding-bottom-20',
    left: 'padding-left-20'
  },
  l30: {
    all: 'padding-30',
    horizontal: 'padding-horizontal-30',
    vertical: 'padding-vertical-30',
    top: 'padding-top-30',
    right: 'padding-right-30',
    bottom: 'padding-bottom-30',
    left: 'padding-left-30'
  }
};
exports.LunaContainerPaddings = LunaContainerPaddings;
var LunaContainerMargins = {
  direction: {
    all: 'all',
    horizontal: 'horizontal',
    vertical: 'vertical',
    top: 'top',
    right: 'right',
    bottom: 'bottom',
    left: 'left'
  },
  size: {
    ten: '10',
    twenty: '20',
    thirty: '30'
  },
  l10: {
    all: 'margin-10',
    horizontal: 'margin-horizontal-10',
    vertical: 'margin-vertical-10',
    top: 'margin-top-10',
    right: 'margin-right-10',
    bottom: 'margin-bottom-10',
    left: 'margin-left-10'
  },
  l20: {
    all: 'margin-20',
    horizontal: 'margin-horizontal-20',
    vertical: 'margin-vertical-20',
    top: 'margin-top-20',
    right: 'margin-right-20',
    bottom: 'margin-bottom-20',
    left: 'margin-left-20'
  },
  l30: {
    all: 'margin-30',
    horizontal: 'margin-horizontal-30',
    vertical: 'margin-vertical-30',
    top: 'margin-top-30',
    right: 'margin-right-30',
    bottom: 'margin-bottom-30',
    left: 'margin-left-30'
  }
};
exports.LunaContainerMargins = LunaContainerMargins;
var LunaContainerThemes = {
  "default": 'default',
  white: 'white',
  neutral1: 'neutral1',
  neutral10: 'neutral10',
  neutral90: 'neutral90'
};
exports.LunaContainerThemes = LunaContainerThemes;

function DEPRECATEDclassKeyFromEnumSet(direction, size) {
  return "".concat(direction).concat(size);
}

function classKeyFromEnumSet(levelKey, directionKey) {
  return "".concat(levelKey, "-").concat(directionKey);
}

function getClasses(_ref, variant) {
  var directions = _ref.direction,
      sizes = _ref.size,
      levels = _objectWithoutProperties(_ref, ["direction", "size"]);

  var classes = _objectSpread(_objectSpread({}, _lodash["default"].reduce(directions, function (acc, direction) {
    var directionClass = direction === 'all' ? '' : "".concat(direction, "-");

    _lodash["default"].forEach(sizes, function (size) {
      acc[DEPRECATEDclassKeyFromEnumSet(direction, size)] = "".concat(__baseClass, "-").concat(variant, "-").concat(directionClass).concat(size);
    });

    return acc;
  }, {})), _lodash["default"].reduce(levels, function (levelsAcc, levelDirections, levelKey) {
    return _objectSpread(_objectSpread({}, levelsAcc), _lodash["default"].reduce(levelDirections, function (acc, levelDirection, directionKey) {
      acc[classKeyFromEnumSet(levelKey, directionKey)] = "".concat(__baseClass, "-").concat(levelDirection);
      return acc;
    }, {}));
  }, {}));

  return classes;
}

var containerClasses = {
  dividers: getClasses(LunaContainerDividers, 'divider'),
  margins: getClasses(LunaContainerMargins, 'margin'),
  paddings: getClasses(LunaContainerPaddings, 'padding'),
  themes: (_themes = {}, _defineProperty(_themes, LunaContainerThemes["default"], null), _defineProperty(_themes, LunaContainerThemes.white, "".concat(__baseClass, "-white")), _defineProperty(_themes, LunaContainerThemes.neutral1, "".concat(__baseClass, "-neutral-1")), _defineProperty(_themes, LunaContainerThemes.neutral10, "".concat(__baseClass, "-neutral-10")), _defineProperty(_themes, LunaContainerThemes.neutral90, "".concat(__baseClass, "-neutral-90")), _themes)
};
exports.containerClasses = containerClasses;
var dividers = {
  all: {
    "default": '',
    ten: "".concat(__baseClass, "-divider-10"),
    twenty: "".concat(__baseClass, "-divider-20"),
    thirty: "".concat(__baseClass, "-divider-30"),
    forty: "".concat(__baseClass, "-divider-40"),
    fourty: "".concat(__baseClass, "-divider-40")
  },
  horizontal: {
    ten: "".concat(__baseClass, "-divider-horizontal-10"),
    twenty: "".concat(__baseClass, "-divider-horizontal-20"),
    thirty: "".concat(__baseClass, "-divider-horizontal-30"),
    forty: "".concat(__baseClass, "-divider-horizontal-40"),
    fourty: "".concat(__baseClass, "-divider-horizontal-40")
  },
  vertical: {
    ten: "".concat(__baseClass, "-divider-vertical-10"),
    twenty: "".concat(__baseClass, "-divider-vertical-20"),
    thirty: "".concat(__baseClass, "-divider-vertical-30"),
    forty: "".concat(__baseClass, "-divider-vertical-40"),
    fourty: "".concat(__baseClass, "-divider-vertical-40")
  },
  top: {
    ten: "".concat(__baseClass, "-divider-top-10"),
    twenty: "".concat(__baseClass, "-divider-top-20"),
    thirty: "".concat(__baseClass, "-divider-top-30"),
    forty: "".concat(__baseClass, "-divider-top-40"),
    fourty: "".concat(__baseClass, "-divider-top-40")
  },
  right: {
    ten: "".concat(__baseClass, "-divider-right-10"),
    twenty: "".concat(__baseClass, "-divider-right-20"),
    thirty: "".concat(__baseClass, "-divider-right-30"),
    forty: "".concat(__baseClass, "-divider-right-40"),
    fourty: "".concat(__baseClass, "-divider-right-40")
  },
  bottom: {
    ten: "".concat(__baseClass, "-divider-bottom-10"),
    twenty: "".concat(__baseClass, "-divider-bottom-20"),
    thirty: "".concat(__baseClass, "-divider-bottom-30"),
    forty: "".concat(__baseClass, "-divider-bottom-40"),
    fourty: "".concat(__baseClass, "-divider-bottom-40")
  },
  left: {
    ten: "".concat(__baseClass, "-divider-top-10"),
    twenty: "".concat(__baseClass, "-divider-top-20"),
    thirty: "".concat(__baseClass, "-divider-top-30"),
    forty: "".concat(__baseClass, "-divider-top-40"),
    fourty: "".concat(__baseClass, "-divider-top-40")
  }
};
exports.dividers = dividers;
var paddings = {
  all: {
    "default": '',
    ten: "".concat(__baseClass, "-padding-10"),
    twenty: "".concat(__baseClass, "-padding-20"),
    thirty: "".concat(__baseClass, "-padding-30")
  },
  horizontal: {
    ten: "".concat(__baseClass, "-padding-horizontal-10"),
    twenty: "".concat(__baseClass, "-padding-horizontal-20"),
    thirty: "".concat(__baseClass, "-padding-horizontal-30")
  },
  vertical: {
    ten: "".concat(__baseClass, "-padding-vertical-10"),
    twenty: "".concat(__baseClass, "-padding-vertical-20"),
    thirty: "".concat(__baseClass, "-padding-vertical-30")
  },
  top: {
    ten: "".concat(__baseClass, "-padding-top-10"),
    twenty: "".concat(__baseClass, "-padding-top-20"),
    thirty: "".concat(__baseClass, "-padding-top-30")
  },
  right: {
    ten: "".concat(__baseClass, "-padding-right-10"),
    twenty: "".concat(__baseClass, "-padding-right-20"),
    thirty: "".concat(__baseClass, "-padding-right-30")
  },
  bottom: {
    ten: "".concat(__baseClass, "-padding-bottom-10"),
    twenty: "".concat(__baseClass, "-padding-bottom-20"),
    thirty: "".concat(__baseClass, "-padding-bottom-30")
  },
  left: {
    ten: "".concat(__baseClass, "-padding-left-10"),
    twenty: "".concat(__baseClass, "-padding-left-20"),
    thirty: "".concat(__baseClass, "-padding-left-30")
  }
};
exports.paddings = paddings;
var themes = {
  "default": null,
  white: "".concat(__baseClass, "-white"),
  neutral1: "".concat(__baseClass, "-neutral-1"),
  neutral10: "".concat(__baseClass, "-neutral-10"),
  neutral90: "".concat(__baseClass, "-neutral-90")
};
exports.themes = themes;
var margins = {
  all: {
    "default": '',
    ten: "".concat(__baseClass, "-margin-10"),
    twenty: "".concat(__baseClass, "-margin-20"),
    thirty: "".concat(__baseClass, "-margin-30")
  },
  horizontal: {
    ten: "".concat(__baseClass, "-margin-horizontal-10"),
    twenty: "".concat(__baseClass, "-margin-horizontal-20"),
    thirty: "".concat(__baseClass, "-margin-horizontal-30")
  },
  vertical: {
    ten: "".concat(__baseClass, "-margin-vertical-10"),
    twenty: "".concat(__baseClass, "-margin-vertical-20"),
    thirty: "".concat(__baseClass, "-margin-vertical-30")
  },
  top: {
    ten: "".concat(__baseClass, "-margin-top-10"),
    twenty: "".concat(__baseClass, "-margin-top-20"),
    thirty: "".concat(__baseClass, "-margin-top-30")
  },
  right: {
    ten: "".concat(__baseClass, "-margin-right-10"),
    twenty: "".concat(__baseClass, "-margin-right-20"),
    thirty: "".concat(__baseClass, "-margin-right-30")
  },
  bottom: {
    ten: "".concat(__baseClass, "-margin-bottom-10"),
    twenty: "".concat(__baseClass, "-margin-bottom-20"),
    thirty: "".concat(__baseClass, "-margin-bottom-30")
  },
  left: {
    ten: "".concat(__baseClass, "-margin-left-10"),
    twenty: "".concat(__baseClass, "-margin-left-20"),
    thirty: "".concat(__baseClass, "-margin-left-30")
  }
};
var DEFAULTS = {
  CLASSES: '',
  DIVIDER: {
    all: dividers.all["default"]
  },
  MARGIN: {
    all: margins.all["default"]
  },
  PADDING: {
    all: paddings.all["default"]
  },
  THEME: themes["default"]
};
exports.DEFAULTS = DEFAULTS;
var ENUMS = {
  divider: dividers,
  margin: margins,
  padding: paddings,
  theme: themes,
  themes: helper.getValueList(themes)
};
exports.ENUMS = ENUMS;
